import { Paper } from '@maas-components/core'
import styled from 'styled-components'

export const PaperStyled = styled(Paper)`
  max-height: 55vh;
`
